module.exports = __webpack_public_path__ + "img/stock_img1.164f4a9e.jpg";